/* eslint-disable react/destructuring-assignment, react/prop-types */

import MusicServiceLogoCard from './MusicServiceLogoCard';

export default function NapsterLogoCard(props) {
  return (
    <MusicServiceLogoCard
      name="Napster"
      bg="#2B5EFF"
      icon={{
        viewBox: '0 0 50 47',
        color: '#fff',
        d: 'M42.699,7.703L45.502,7.703L45.502,12.628L45.567,12.692C48.24,13.891 50,16.543 50,19.448C50,22.289 48.24,24.941 45.567,26.204L45.502,26.267L45.502,26.393C45.437,37.254 36.245,46.094 25.033,46.094C13.82,46.094 4.628,37.254 4.563,26.393L4.563,26.267L4.433,26.267C1.76,25.067 0,22.415 0,19.511C0,16.606 1.76,13.954 4.433,12.755L4.498,12.692L4.498,7.766L7.366,7.766C7.823,7.766 8.279,7.766 8.735,7.83L8.801,7.83L8.866,7.766C12.647,2.905 18.774,0 25.033,0C31.291,0 37.353,2.905 41.199,7.703L41.265,7.766L41.33,7.766C41.786,7.703 42.243,7.703 42.699,7.703ZM14.211,9.345L14.016,9.471L14.407,9.598C15.124,9.976 15.906,10.482 16.623,10.987L16.688,11.05L16.754,10.987C18.644,10.04 21.643,8.966 25.098,8.966C28.553,8.966 31.551,10.04 33.442,10.987L33.507,11.05L33.572,10.987C34.289,10.482 35.006,10.04 35.789,9.598L35.984,9.471L35.854,9.345C32.986,6.567 29.074,4.988 25.033,4.988C20.991,4.988 17.08,6.567 14.211,9.345ZM39.896,26.204L39.961,26.204L39.961,13.702L39.765,13.765C37.093,14.396 34.681,17.175 34.094,17.869C33.442,17.238 30.378,14.46 25.033,14.46C19.687,14.46 16.623,17.175 15.971,17.869C15.385,17.175 12.907,14.396 10.3,13.765L10.104,13.702L10.104,26.204C10.104,34.16 16.754,40.664 24.967,40.664C33.181,40.664 39.896,34.16 39.896,26.204Z',
      }}
      nameMargin={props.nameMargin}
      maxW={props.maxW}
      link={props.link}
    />
  );
}
